export const ALEIS_EID8500_ALLFLEX_RS420_SCANNER_DRIVER_NAME =
  "aleiseid8500-scanner";
